import { render, staticRenderFns } from "./mr_popover.vue?vue&type=template&id=a277a3bc"
import script from "./mr_popover.vue?vue&type=script&lang=js"
export * from "./mr_popover.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports